import axios from "axios"

// VTPass API configuration
const VTPASS_BASE_URL = "https://vtpass.com/api"
const VTPASS_API_KEY = process.env.REACT_APP_VTPASS_API_KEY
const VTPASS_SECRET_KEY = process.env.REACT_APP_VTPASS_SECRET_KEY

// Create axios instance for VTPass
const vtpassApi = axios.create({
  baseURL: VTPASS_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "api-key": VTPASS_API_KEY,
    "secret-key": VTPASS_SECRET_KEY,
  },
})

// Mock data for fallback
const mockDataPlans = {
  mtn: [
    { id: "mtn-1gb", name: "1GB - 30 Days", price: 350, data: "1GB", validity: "30 days" },
    { id: "mtn-2gb", name: "2GB - 30 Days", price: 700, data: "2GB", validity: "30 days" },
    { id: "mtn-3gb", name: "3GB - 30 Days", price: 1050, data: "3GB", validity: "30 days" },
    { id: "mtn-5gb", name: "5GB - 30 Days", price: 1750, data: "5GB", validity: "30 days" },
    { id: "mtn-10gb", name: "10GB - 30 Days", price: 3500, data: "10GB", validity: "30 days" },
  ],
  airtel: [
    { id: "airtel-1gb", name: "1GB - 30 Days", price: 360, data: "1GB", validity: "30 days" },
    { id: "airtel-2gb", name: "2GB - 30 Days", price: 720, data: "2GB", validity: "30 days" },
    { id: "airtel-3gb", name: "3GB - 30 Days", price: 1080, data: "3GB", validity: "30 days" },
    { id: "airtel-5gb", name: "5GB - 30 Days", price: 1800, data: "5GB", validity: "30 days" },
    { id: "airtel-10gb", name: "10GB - 30 Days", price: 3600, data: "10GB", validity: "30 days" },
  ],
  glo: [
    { id: "glo-1gb", name: "1GB - 30 Days", price: 340, data: "1GB", validity: "30 days" },
    { id: "glo-2gb", name: "2GB - 30 Days", price: 680, data: "2GB", validity: "30 days" },
    { id: "glo-3gb", name: "3GB - 30 Days", price: 1020, data: "3GB", validity: "30 days" },
    { id: "glo-5gb", name: "5GB - 30 Days", price: 1700, data: "5GB", validity: "30 days" },
    { id: "glo-10gb", name: "10GB - 30 Days", price: 3400, data: "10GB", validity: "30 days" },
  ],
  "9mobile": [
    { id: "9mobile-1gb", name: "1GB - 30 Days", price: 370, data: "1GB", validity: "30 days" },
    { id: "9mobile-2gb", name: "2GB - 30 Days", price: 740, data: "2GB", validity: "30 days" },
    { id: "9mobile-3gb", name: "3GB - 30 Days", price: 1110, data: "3GB", validity: "30 days" },
    { id: "9mobile-5gb", name: "5GB - 30 Days", price: 1850, data: "5GB", validity: "30 days" },
    { id: "9mobile-10gb", name: "10GB - 30 Days", price: 3700, data: "10GB", validity: "30 days" },
  ],
}

const mockCablePlans = {
  dstv: [
    { id: "dstv-compact", name: "DStv Compact", price: 10500, duration: "1 month" },
    { id: "dstv-compact-plus", name: "DStv Compact Plus", price: 16600, duration: "1 month" },
    { id: "dstv-premium", name: "DStv Premium", price: 24500, duration: "1 month" },
    { id: "dstv-family", name: "DStv Family", price: 4200, duration: "1 month" },
  ],
  gotv: [
    { id: "gotv-smallie", name: "GOtv Smallie", price: 1100, duration: "1 month" },
    { id: "gotv-jinja", name: "GOtv Jinja", price: 2250, duration: "1 month" },
    { id: "gotv-jolli", name: "GOtv Jolli", price: 3300, duration: "1 month" },
    { id: "gotv-max", name: "GOtv Max", price: 4850, duration: "1 month" },
  ],
  startimes: [
    { id: "startimes-nova", name: "StarTimes Nova", price: 1200, duration: "1 month" },
    { id: "startimes-basic", name: "StarTimes Basic", price: 2200, duration: "1 month" },
    { id: "startimes-smart", name: "StarTimes Smart", price: 2800, duration: "1 month" },
    { id: "startimes-classic", name: "StarTimes Classic", price: 3200, duration: "1 month" },
  ],
}

// API Functions
export const getDataPlans = async (network) => {
  try {
    // Try real API first
    if (VTPASS_API_KEY) {
      const response = await vtpassApi.get(`/service-variations?serviceID=${network}-data`)
      return response.data.content.variations
    }
  } catch (error) {
    console.log("API call failed, using mock data:", error.message)
  }

  // Fallback to mock data
  return mockDataPlans[network.toLowerCase()] || []
}

export const purchaseData = async (purchaseData) => {
  try {
    // Try real API first
    if (VTPASS_API_KEY) {
      const response = await vtpassApi.post("/pay", {
        request_id: Date.now().toString(),
        serviceID: `${purchaseData.network.toLowerCase()}-data`,
        billersCode: purchaseData.phone,
        variation_code: purchaseData.planId,
        amount: purchaseData.amount,
        phone: purchaseData.phone,
      })
      return response.data
    }
  } catch (error) {
    console.log("API call failed, using mock response:", error.message)
  }

  // Simulate API delay and return mock response
  await new Promise((resolve) => setTimeout(resolve, 2000))

  return {
    code: "000",
    content: {
      transactions: {
        status: "delivered",
        product_name: purchaseData.planName,
        unique_element: purchaseData.phone,
        unit_price: purchaseData.amount,
        quantity: 1,
        service_verification: null,
        channel: "api",
        commission: 0,
        total_amount: purchaseData.amount,
        discount: null,
        type: "data",
        email: null,
        phone: purchaseData.phone,
        name: null,
        convinience_fee: 0,
        amount: purchaseData.amount,
        platform: "api",
        method: "api",
        transactionId: `TXN${Date.now()}`,
      },
    },
    response_description: "TRANSACTION SUCCESSFUL",
    requestId: Date.now().toString(),
    amount: purchaseData.amount,
    transaction_date: new Date().toISOString(),
    purchased_code: "",
  }
}

export const purchaseAirtime = async (purchaseData) => {
  try {
    // Try real API first
    if (VTPASS_API_KEY) {
      const response = await vtpassApi.post("/pay", {
        request_id: Date.now().toString(),
        serviceID: `${purchaseData.network.toLowerCase()}`,
        amount: purchaseData.amount,
        phone: purchaseData.phone,
      })
      return response.data
    }
  } catch (error) {
    console.log("API call failed, using mock response:", error.message)
  }

  // Simulate API delay and return mock response
  await new Promise((resolve) => setTimeout(resolve, 1500))

  return {
    code: "000",
    content: {
      transactions: {
        status: "delivered",
        product_name: `${purchaseData.network} Airtime`,
        unique_element: purchaseData.phone,
        unit_price: purchaseData.amount,
        quantity: 1,
        service_verification: null,
        channel: "api",
        commission: 0,
        total_amount: purchaseData.amount,
        discount: null,
        type: "airtime",
        email: null,
        phone: purchaseData.phone,
        name: null,
        convinience_fee: 0,
        amount: purchaseData.amount,
        platform: "api",
        method: "api",
        transactionId: `TXN${Date.now()}`,
      },
    },
    response_description: "TRANSACTION SUCCESSFUL",
    requestId: Date.now().toString(),
    amount: purchaseData.amount,
    transaction_date: new Date().toISOString(),
    purchased_code: "",
  }
}

export const getCablePlans = async (provider) => {
  try {
    // Try real API first
    if (VTPASS_API_KEY) {
      const response = await vtpassApi.get(`/service-variations?serviceID=${provider}`)
      return response.data.content.variations
    }
  } catch (error) {
    console.log("API call failed, using mock data:", error.message)
  }

  // Fallback to mock data
  return mockCablePlans[provider.toLowerCase()] || []
}

export const payCableBill = async (billData) => {
  try {
    // Try real API first
    if (VTPASS_API_KEY) {
      const response = await vtpassApi.post("/pay", {
        request_id: Date.now().toString(),
        serviceID: billData.provider.toLowerCase(),
        billersCode: billData.smartCardNumber,
        variation_code: billData.planId,
        amount: billData.amount,
        phone: billData.phone,
      })
      return response.data
    }
  } catch (error) {
    console.log("API call failed, using mock response:", error.message)
  }

  // Simulate API delay and return mock response
  await new Promise((resolve) => setTimeout(resolve, 2000))

  return {
    code: "000",
    content: {
      transactions: {
        status: "delivered",
        product_name: billData.planName,
        unique_element: billData.smartCardNumber,
        unit_price: billData.amount,
        quantity: 1,
        service_verification: null,
        channel: "api",
        commission: 0,
        total_amount: billData.amount,
        discount: null,
        type: "cable",
        email: null,
        phone: billData.phone,
        name: null,
        convinience_fee: 0,
        amount: billData.amount,
        platform: "api",
        method: "api",
        transactionId: `TXN${Date.now()}`,
      },
    },
    response_description: "TRANSACTION SUCCESSFUL",
    requestId: Date.now().toString(),
    amount: billData.amount,
    transaction_date: new Date().toISOString(),
    purchased_code: "",
  }
}

export const payElectricityBill = async (billData) => {
  // Simulate API delay and return mock response
  await new Promise((resolve) => setTimeout(resolve, 2000))

  return {
    code: "000",
    content: {
      transactions: {
        status: "delivered",
        product_name: `${billData.provider} Electricity`,
        unique_element: billData.meterNumber,
        unit_price: billData.amount,
        quantity: 1,
        service_verification: null,
        channel: "api",
        commission: 0,
        total_amount: billData.amount,
        discount: null,
        type: "electricity",
        email: null,
        phone: billData.phone,
        name: null,
        convinience_fee: 0,
        amount: billData.amount,
        platform: "api",
        method: "api",
        transactionId: `TXN${Date.now()}`,
      },
    },
    response_description: "TRANSACTION SUCCESSFUL",
    requestId: Date.now().toString(),
    amount: billData.amount,
    transaction_date: new Date().toISOString(),
    purchased_code: `${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
  }
}
